// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"1781465e","611":"9105c36f","787":"3cb8f6cd","911":"1d190531","978":"52cb63d7"}[chunkId] + ".chunk.js";
};